import { Link } from '@/navigation';
import Image from 'next/image';

import FacebookIcon from 'public/images/social/facebook-color.svg';
import InstagramIcon from 'public/images/social/instagram.svg';
import LinkedinIcon from 'public/images/social/linkedin.svg';
import TiktokIcon from 'public/images/social/tiktok.svg';
import XIcon from 'public/images/social/x.svg';
import YoutubeIcon from 'public/images/social/youtube.svg';

import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import type { FooterResponse } from '@/features/footer/api/types';
import { Article } from '@phosphor-icons/react';
import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';

type Props = {
  footerData: FooterResponse;
  classNames?: string;
  sectionClassNames?: string;
  showTitle?: boolean;
};

const SocialMedia = ({
  footerData,
  classNames,
  showTitle = true,
  sectionClassNames,
}: Props) => {
  const t = useTranslations('checkout.confirmation');
  const getIcon = (icon: string) => {
    switch (icon) {
      case 'facebook':
        return FacebookIcon;
      case 'instagram':
        return InstagramIcon;
      case 'tiktok':
        return TiktokIcon;
      case 'linkedin':
        return LinkedinIcon;
      case 'youtube':
        return YoutubeIcon;
      case 'twitter':
        return XIcon;
      default:
        return '';
    }
  };

  return (
    footerData?.socialLinks?.length > 0 && (
      <div
        className={clsx(
          'mt-m flex flex-col items-center justify-center',
          classNames,
        )}
      >
        {showTitle && <span className="mb-xxs">{t('socials_title')}</span>}
        <div
          className={clsx(
            'flex items-center justify-center',
            sectionClassNames,
          )}
        >
          {footerData?.socialLinks?.map(
            ({ href, title, name }) =>
              getIcon(name.toLowerCase()) && (
                <Link
                  key={name}
                  href={href}
                  target="_blank"
                  rel="nofollow"
                  className="flex min-h-clickable min-w-clickable items-center justify-center"
                >
                  <Image
                    src={getIcon(name.toLowerCase())}
                    alt={title}
                    width={21}
                    height={21}
                    className="aspect-square h-auto w-auto"
                  />
                </Link>
              ),
          )}
        </div>
        <Link
          href={footerData.blogLink.href}
          prefetch={false}
          target="_blank"
          className="flex min-h-clickable items-center justify-center gap-xxs no-flex-gap:space-x-xxs"
        >
          <PhosphorIcon Icon={Article} className="icon-m" variant="bold" />
          <span>{footerData.blogLink.title}</span>
        </Link>
      </div>
    )
  );
};

export default SocialMedia;
